<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        viewBox="0 0 16 16"
        :aria-labelledby="props.ariaLabelledby"
        :aria-hidden="!props.ariaLabelledby"
        role="img"
    >
        <path
            fill="currentColor"
            d="M3.725 8.942A1.284 1.284 0 0 1 3.333 8c0-.367.131-.68.392-.942.261-.26.575-.391.942-.391.366 0 .68.13.941.391C5.87 7.32 6 7.633 6 8s-.13.68-.392.942a1.284 1.284 0 0 1-.941.391c-.367 0-.68-.13-.942-.391ZM4.667 12c-1.111 0-2.056-.389-2.834-1.167C1.056 10.056.667 9.111.667 8c0-1.111.389-2.056 1.166-2.833C2.611 4.389 3.556 4 4.667 4c.744 0 1.42.183 2.025.55.605.367 1.086.85 1.441 1.45H14l2 2-3 3-1.333-1-1.334 1-1.416-1h-.784a4.142 4.142 0 0 1-1.441 1.45 3.83 3.83 0 0 1-2.025.55Zm0-1.333c.622 0 1.17-.19 1.641-.567.473-.378.787-.856.942-1.433h2.083l.967.683 1.367-1.017 1.183.917L14.1 8l-.667-.667H7.25A2.688 2.688 0 0 0 6.308 5.9a2.552 2.552 0 0 0-1.641-.567c-.734 0-1.361.261-1.884.784A2.568 2.568 0 0 0 2 8c0 .733.261 1.361.783 1.883.523.523 1.15.784 1.884.784Z"
        />
    </svg>
</template>

<script setup lang="ts">
type PasswordIconProps = {
    ariaLabelledby?: string;
};

const props = defineProps<PasswordIconProps>();
</script>
